var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M3.583.303c-.75-.41-1.63-.4-2.374.006l8.73 7.97 2.932-2.902zm-3.247.822C.123 1.47 0 1.865 0 2.283v14.395c0 .405.11.792.312 1.13l8.779-8.69zM16.76 7.5l-2.798-1.527-3.143 3.11L14.67 12.6l2.09-1.142c.752-.412 1.202-1.152 1.202-1.979-.001-.827-.45-1.567-1.203-1.978zM9.972 9.922 1.17 18.635c.382.215.801.329 1.223.329a2.5 2.5 0 0 0 1.191-.307l9.984-5.453z"
  })));
};
export default SvgAndroid;